// Vendors
import { FooterComponent } from '@openbank/ziniaweb-ui-components';
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Constants
import {
  CANCEL_DROP_MODAL_COMPONENT_FOOTER_ACTION_BUTTON_PROPS,
  CANCEL_DROP_MODAL_COMPONENT_FOOTER_GHOST_BUTTON_PROPS,
  CANCEL_DROP_MODAL_COMPONENT_FOOTER_PROPS,
} from './constants/cancel-drop-modal-footer.constants';
// Hooks
import { useCancelDropModalHook } from './hooks/cancel-drop-modal-footer.hook';
// Translations
import {
  CANCEL_BUTTON,
  CONTINUE_BUTTON,
} from './translations/cancel-drop-modal-footer.translations';
// Types
import { CancelDropModalComponentType } from '../../types/cancel-drop-modal.component.type';

const CancelDropModalFooterComponent = ({
  footerConfiguration,
  id,
  onLinkClose,
}: Pick<
  CancelDropModalComponentType,
  'footerConfiguration' | 'id' | 'onLinkClose'
>): React.JSX.Element => {
  const { loading, handleConfirmDropOnboardingProcessButtonClick } = useCancelDropModalHook(id);

  return (
    <FooterComponent
      {...CANCEL_DROP_MODAL_COMPONENT_FOOTER_PROPS}
      buttonGhostConfiguration={{
        ...CANCEL_DROP_MODAL_COMPONENT_FOOTER_GHOST_BUTTON_PROPS,
        disabled: loading,
        children: <FormattedMessage id={footerConfiguration?.cancelLink ?? CANCEL_BUTTON} />,
        onClick: onLinkClose,
      }}
      mainButtonConfiguration={{
        ...CANCEL_DROP_MODAL_COMPONENT_FOOTER_ACTION_BUTTON_PROPS,
        loading,
        children: <FormattedMessage id={footerConfiguration?.continueButton ?? CONTINUE_BUTTON} />,
        onClick: handleConfirmDropOnboardingProcessButtonClick,
      }}
    />
  );
};

export { CancelDropModalFooterComponent };
